export const getPathFromPageId = ({
  pageId,
  cohort,
  uuid,
  testEnvironmentQueryParam,
}: {
  pageId: string
  cohort: string | null
  uuid: string
  testEnvironmentQueryParam: string
}): string =>
  `${pageId}?cohort=${cohort}&uuid=${uuid}${testEnvironmentQueryParam}`
